import { FormControl, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { FormControlBase } from './form-control-base';
import { FormDoubleControlData } from './form-control-data';

export class AutoCompleteDoubleControl extends FormControlBase<any> {
  controlType = 'autocomplete-double';

  leftKey: string;
  leftFormControlId: string;
  leftPlaceholder: string;
  leftFieldName: string;
  rightFormControlId: string;
  rightFieldName: string;
  valueFieldName: string;

  leftValue: any = '';
  rightValue: any = '';
  idValue: any = undefined;
  leftFormControl: FormControl;
  allowUserEntry: boolean = true;
  allowBrowserAutocomplete: boolean = true;

  onChange = new Subject();

  constructor(options: FormDoubleControlData<any>) {
    super(options);
    this.leftKey = options.leftKey;
    this.leftFormControlId = options.leftFormControlId;
    this.leftPlaceholder = options.leftPlaceholder;
    this.leftFieldName = options.leftFieldName;
    this.rightFormControlId = options.rightFormControlId;
    this.rightFieldName = options.rightFieldName;
    this.valueFieldName = options.valueFieldName;
    this.placeholder = options.rightPlaceholder;
  }

  protected initialize() {
    const leftVal = _.get(this.model, this.propertyName + '.' + this.leftFieldName);
    const rightVal = _.get(this.model, this.propertyName + '.' + this.rightFieldName);
    this.leftValue = leftVal ? leftVal : this.defaultValue;
    this.rightValue = rightVal ? rightVal : this.defaultValue;
    this.setFormControlValues();
  }

  commit() {
    _.set(this.model, this.propertyName + '.' + this.leftFieldName, this.leftValue);
    _.set(this.model, this.propertyName + '.' + this.rightFieldName, this.rightValue);
    _.set(this.model, this.propertyName + '.' + this.valueFieldName, this.idValue);
  }

  setFormControl(formControl: FormControl, group?: FormGroup) {
    this.formControl = formControl;
    this.leftFormControl = new FormControl({ value: this.leftValue, disabled: this.disabled } || '');
    this.setFormControlValues();

    if (group) {
      group.addControl(this.leftKey, this.leftFormControl);
    }

    this.setValidators();
  }

  private setFormControlValues() {
    if (!this.formControl) {
      this.formControl = new FormControl({ value: this.rightValue, disabled: this.disabled } || '');
    }

    if (!this.leftFormControl) {
      this.leftFormControl = new FormControl({ value: this.leftValue, disabled: this.disabled } || '');
    }

    this.formControl.setValue(this.rightValue);
    this.leftFormControl.setValue(this.leftValue);
  }

  public updateValues() {
    if (this.formControl && this.rightValue) {
      this.formControl.setValue(this.rightValue);
    }
    if (this.leftFormControl && this.leftValue) {
      this.leftFormControl.setValue(this.leftValue);
    }
  }

  get disabled() {
    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = value;
    if (this.formControl) {
      this._disabled ? this.formControl.disable() : this.formControl.enable();
    }
    if (this.leftFormControl) {
      this._disabled ? this.leftFormControl.disable() : this.leftFormControl.enable();
    }
  }

  leftOnChange(value: any) {
    this.leftValue = value;

    let retValue = {};
    retValue[this.leftFieldName] = this.leftValue;
    retValue[this.rightFieldName] = this.rightValue;
    retValue[this.valueFieldName] = undefined;
    this.idValue = undefined;
    if (!this.options) {
      return;
    }
    const chosenItem = _.find(this.options, it => it[this.leftFieldName] === value);
    if (chosenItem) {
      retValue = chosenItem;
      this.rightValue = chosenItem[this.rightFieldName];
      this.idValue = chosenItem[this.valueFieldName];
      if (this.formControl) {
        this.formControl.setValue(this.rightValue);
      }
    }
    this.onChange.next(retValue);
  }

  rightOnChange(value: any) {
    this.rightValue = value;

    let retValue = {};
    retValue[this.rightFieldName] = value;
    retValue[this.leftFieldName] = this.leftValue;
    retValue[this.valueFieldName] = undefined;
    this.idValue = undefined;
    if (!this.options) {
      return;
    }
    const chosenItem = _.find(this.options, it => it[this.rightFieldName] === value);
    if (chosenItem) {
      retValue = chosenItem;
      this.leftValue = chosenItem[this.leftFieldName];
      this.idValue = chosenItem[this.valueFieldName];
      if (this.leftFormControl) {
        this.leftFormControl.setValue(this.leftValue);
      }
    }
    this.onChange.next(retValue);
  }
}
